import { render, staticRenderFns } from "./VTemplateBuilder.vue?vue&type=template&id=383db55f&"
import script from "./VTemplateBuilder.vue?vue&type=script&lang=js&"
export * from "./VTemplateBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports